import React from 'react'
import dreamstars_logo from "../../Image/dreamstars_logo.png"
import Footer from './Footer'


import { Link } from 'react-router-dom'



const JoinPage = () => {
    return (
        <>
         
            
            <div className='flex md:flex-row flex-col h-screen w-screen justify-center joinM'>
        
                <div
                    className=' font-museo bg-cover bg-center bg-no-repeat md:w-[50vw] w-screen  h-full flex items-center justify-center  ' >
                    <Link to="/" ><img src={dreamstars_logo} className=" headerSize cursor-pointer absolute top-5 left-8 w-[40%] sm:w-[25%] lg:w-[18%] " alt="back_img" ></img></Link>
                    <Link to="/brand-signin" className='hover:no-underline' > <h2 className='font-museob textShad text-4xl  md:text-3xl lg:text-5xl text-white  cursor-pointer hover:border-4 py-1 px-6 rounded-lg border-white w-fit  ' >I'm a <span className="font-museobb" >Brand</span></h2></Link>
                </div>

              
                <div 
                    className=' font-museo bg-cover bg-center bg-no-repeat md:w-[50vw] w-screen h-full flex items-center justify-center  ' >
                    <Link to="/influencer-signin" className='hover:no-underline' > <h2 className=' textShad text-4xl  md:text-3xl lg:text-5xl text-white  cursor-pointer hover:border-4  py-1 px-6 rounded-lg border-white w-fit  ' >I'm a <span className="font-museobb" >Influencer</span></h2> </Link>
                </div>

              
                <div className='absolute bottom-0 w-full' ><Footer colorClass="footerColor2" clas="footer"  /></div>
            </div>
           

        </>
    )
}

export default JoinPage
